module.exports = __webpack_public_path__ + "static/media/vgn builders ice cream1.679b3507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vgn builders ice cream1.jpg
// module id = 195
// module chunks = 0